import React from 'react';
 
import Privacy from './PrivacyPolicy'
import UsePolicy from './UsePolicy'


const SiteAgreement = (props)=>{
  return(<div>
<h2>SITE POLICY AGREEMENT</h2>
<p>Thank you for visiting this website (this “Site”).  If you do not agree to all of the terms contained herein, please do not use the Site.</p>
<p>LAST REVISED: July 7, 2018</p>
<UsePolicy/>
<Privacy/>

</div>
)
}

export default SiteAgreement;


// WEBPACK FOOTER //
// ./src/container/Pages/Policies/SiteAgreement.js